import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { heroData } from '../data/mock';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const navLinks = [
    { label: 'About', href: '/#biography' },
    { label: 'Achievements', href: '/#achievements' },
    { label: 'Timeline', href: '/timeline' },
    { label: 'Publications', href: '/#publications' },
    { label: 'Documents', href: '/#documents' },
    { label: 'Contact', href: '/#contact' }
  ];

  const handleNavClick = (e, href) => {
    setIsMenuOpen(false);
    
    if (href.startsWith('/#')) {
      e.preventDefault();
      const hash = href.replace('/', '');

      const scrollToTarget = () => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      if (location.pathname === '/') {
        scrollToTarget();
      } else {
        navigate({ pathname: '/', hash });
      }
    }
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="header-logo">
          <span className="logo-text">R</span>
          <span className="logo-full">{heroData.name.split(' ')[0]}</span>
        </Link>
        
        <nav className={`header-nav ${isMenuOpen ? 'nav-open' : ''}`}>
          {navLinks.map((link, index) => (
            <a 
              key={index} 
              href={link.href} 
              className="nav-link"
              onClick={(e) => handleNavClick(e, link.href)}
            >
              {link.label}
            </a>
          ))}
          <a 
            href="tel:+15124348560" 
            className="btn-primary nav-cta"
          >
            Get in Touch
          </a>
        </nav>
        
        <button 
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;